import { Link } from "react-router-dom";
import { Mail, MapPin, Phone } from "lucide-react";
import { PRACTITIONER, AREAS, METHODS } from "@/data/site";
import Newsletter from "@/components/Newsletter";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0C2340] text-[#F0F4F8] mt-16"
    >
      <div className="container-fxv py-20 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-4">
          <p className="overline text-[#C5A059]">Cabinet</p>
          <h3 className="font-serif text-3xl mt-3 text-white">
            {PRACTITIONER.name}
          </h3>
          <p className="text-sm text-[#C9D4E3] mt-2">{PRACTITIONER.title}</p>
          <p className="text-sm text-[#C9D4E3] mt-6 leading-relaxed">
            Cabinet de psychologie et psychothérapie à Paris 16e. Consultations
            en cabinet et en visioconsultation pour adultes.
          </p>
          <div className="mt-8 space-y-3 text-sm">
            <a
              href={`tel:${PRACTITIONER.phone}`}
              data-testid="footer-phone"
              className="flex items-center gap-3 hover:text-[#C5A059] transition-colors"
            >
              <Phone size={16} strokeWidth={1.5} />
              {PRACTITIONER.phoneDisplay}
            </a>
            <a
              href={`mailto:${PRACTITIONER.email}`}
              data-testid="footer-email"
              className="flex items-center gap-3 hover:text-[#C5A059] transition-colors"
            >
              <Mail size={16} strokeWidth={1.5} />
              {PRACTITIONER.email}
            </a>
            <div className="flex items-center gap-3">
              <MapPin size={16} strokeWidth={1.5} />
              {PRACTITIONER.address}
            </div>
          </div>
        </div>

        <div className="md:col-span-2">
          <p className="overline">Navigation</p>
          <ul className="mt-4 space-y-3 text-sm">
            {[
              ["Accueil", "/"],
              ["À propos", "/a-propos"],
              ["Domaines", "/domaines"],
              ["Méthodes", "/methodes"],
              ["Blog", "/blog"],
              ["FAQ", "/faq"],
              ["Contact", "/contact"],
            ].map(([label, to]) => (
              <li key={to}>
                <Link
                  to={to}
                  className="text-[#C9D4E3] hover:text-[#C5A059] transition-colors"
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <p className="overline">Domaines</p>
          <ul className="mt-4 space-y-3 text-sm">
            {AREAS.map((a) => (
              <li key={a.slug}>
                <Link
                  to={`/domaines/${a.slug}`}
                  className="text-[#C9D4E3] hover:text-[#C5A059] transition-colors"
                >
                  {a.short}
                </Link>
              </li>
            ))}
          </ul>
          <p className="overline mt-8">Méthodes</p>
          <ul className="mt-4 grid grid-cols-2 gap-y-2 text-sm">
            {METHODS.slice(0, 6).map((m) => (
              <li key={m.slug}>
                <Link
                  to={`/methodes/${m.slug}`}
                  className="text-[#C9D4E3] hover:text-[#C5A059] transition-colors"
                >
                  {m.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <p className="overline">Newsletter</p>
          <p className="text-sm text-[#C9D4E3] mt-4 leading-relaxed">
            Recevez des éclairages bienveillants sur l'équilibre émotionnel. Pas
            de spam. Désinscription en un clic.
          </p>
          <div className="mt-4">
            <Newsletter />
          </div>
        </div>
      </div>

      <div className="border-t border-[#1A3454]">
        <div className="container-fxv py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-[#9CB0CC]">
          <p>
            © {new Date().getFullYear()} {PRACTITIONER.name}. Tous droits
            réservés. — Site informatif, ne se substitue pas à un avis médical.
          </p>
          <div className="flex gap-6">
            <Link to="/mentions-legales" className="hover:text-[#C5A059]">
              Mentions légales
            </Link>
            <Link to="/confidentialite" className="hover:text-[#C5A059]">
              Confidentialité
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
